import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		cashWaterList: [],
		cashWaterPager: {
			sizes: [20, 200, 500 ,5000],
		},
		loading: false,
		partnerRechangeList: [],
		partnerRechangePager: {},
		smsRechargeList: [],
		smsrRechangePager: {},
		analyzeDayList: [],
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获取付款流水列表
		async getCashWaterList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/admin/cash',
                params
			})
			commit('setState',{key:'cashWaterList',data: res.docs})
			commit('setState',{key:'cashWaterPager',data: {limit: res.limit,total: res.total}})
            commit('setState',{key:'loading',data: false})
		},
		// 重置付款明细
		async restDetail({ commit }: any, id: string) {
			commit('setState',{key:'loading',data: true})
			const res = fetch({
				url: `/admin/cash/reset/${id}`,
				method: 'put'
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 获取快递员充值列表
		async getPartnerRechangeList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/admin/capitalflow',
                params
			})
			commit('setState',{key:'partnerRechangeList',data: res.docs})
			commit('setState',{key:'partnerRechangePager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
            
		},
		// 短信费充值记录
		async getSmsRechargeList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/iforder',
				params
			})
			console.log(res);
			
			commit('setState',{key:'smsRechargeList',data: res.docs})
			commit('setState',{key:'smsrRechangePager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
		},
		// 财务月报
		async getAnalyzeList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
				url: '/admin/monthReport',
				params
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 修改财务分析列表
		async putAnalyzeList({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/financeReport/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 获得日报
		async getAnalyzeDayList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/daysReport',
				params
			})
			commit('setState',{key:'loading',data: false})
			commit('setState',{key:'analyzeDayList',data: res})
		},
		// 创建日报
		async createdExcel({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/daysReport',
				method: 'post',
				data: params
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		async exportCash({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/capitalflow/exportToExcel',
				method: 'post',
				data: params
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 导出流水
		
		
	}
}